import React from 'react';
import './reviewCard.css'

function C2wReviewCard({ obj }) {
    return (
        <div className='C2wReviewCard_ctn'>
            <div className='reviewerName'>{obj?.name}</div>
            <div className='C2wReviewerStarr'>
                {[...Array(5)].map((_, index) => (
                    index+1 <= obj?.stars ? (
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.1829 0.465795C12.2986 0.231318 12.633 0.231319 12.7487 0.465796L16.3149 7.69168C16.3608 7.78479 16.4497 7.84932 16.5524 7.86425L24.5267 9.02298C24.7854 9.06058 24.8887 9.37857 24.7015 9.56109L18.9313 15.1856C18.8569 15.2581 18.823 15.3625 18.8406 15.4649L20.2027 23.4069C20.2469 23.6646 19.9764 23.8611 19.745 23.7395L12.6126 19.9898C12.5207 19.9414 12.4109 19.9414 12.319 19.9898L5.18663 23.7395C4.95519 23.8611 4.68469 23.6646 4.72889 23.4069L6.09105 15.4649C6.10861 15.3625 6.07468 15.2581 6.00032 15.1856L0.230114 9.56108C0.0428733 9.37857 0.146196 9.06058 0.404956 9.02298L8.37919 7.86425C8.48194 7.84932 8.57077 7.78479 8.61672 7.69168L12.1829 0.465795Z" fill="#FCAE10" />
                        </svg>

                    ) : (
                        <svg width="25" height="24" viewBox="0 0 25 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.1575 0.465795C12.2732 0.231318 12.6076 0.231319 12.7233 0.465796L16.2895 7.69168C16.3355 7.78479 16.4243 7.84932 16.527 7.86425L24.5013 9.02298C24.76 9.06058 24.8633 9.37857 24.6761 9.56109L18.9059 15.1856C18.8315 15.2581 18.7976 15.3625 18.8152 15.4649L20.1773 23.4069C20.2215 23.6646 19.951 23.8611 19.7196 23.7395L12.5872 19.9898C12.4953 19.9414 12.3855 19.9414 12.2936 19.9898L5.16124 23.7395C4.9298 23.8611 4.6593 23.6646 4.7035 23.4069L6.06566 15.4649C6.08321 15.3625 6.04929 15.2581 5.97493 15.1856L0.204724 9.56108C0.0174826 9.37857 0.120805 9.06058 0.379566 9.02298L8.3538 7.86425C8.45655 7.84932 8.54538 7.78479 8.59133 7.69168L12.1575 0.465795Z" fill="#3C3E4E" />
                        </svg>
                    )

                ))}

            </div>
            <p>{obj?.reviewDesc}</p>
        </div>
    )
}

export default C2wReviewCard
